export default __webpack_public_path__ + "static/media/form-right.14c49605.svg";